module.exports = __webpack_public_path__ + "img/slider-actors-caption.ce7c805e.png";